import "./assets/fonts/fonts.css";
import '@splidejs/splide/dist/css/splide.min.css';
import "./styles/main.css";
import "./styles/layouts/blockgridlayout.css";
import "../css/index.css";

import "flowbite";
import _, { map } from 'underscore';
import "./scripts/global/cookie.js";
import "./scripts/global/navigationBar.js";
import "./scripts/modules/masthead.js";

import "./scripts/global/tabs.js"


import "./scripts/modules/embedVideoRow.js";
import "./scripts/modules/boatLayout.js";
import "./scripts/modules/comparePage.js";
import "./scripts/modules/dealerLookup.js";
import "./scripts/modules/eventsPage.js";
import "./scripts/modules/knowledgehubpage.js";
import "./scripts/modules/heroVerticalSliderRow.js";
import "./scripts/modules/galleryScroll.js";

import "./scripts/salesforce/countries.js";
import "./scripts/salesforce/salesforceForms.js";
import "./scripts/salesforce/salesforceForm-Tabs.js";


import (/* webpackChunkName: "splide-carousel" */'./scripts/modules/carousel.js');
import (/* webpackChunkName: "accordian" */'./scripts/modules/accordion.js');


/** export lib functions */
export {
    playPause,
  } from "./scripts/modules/videoWithThumbnail.js";
export { showModal } from "./scripts/utilities/Util.js"

/** Media Carousel Row: load on demand */
if (document.querySelector(".js--mediaCarouselRow")) {
    import(/* webpackChunkName: "media-carousel-row", webpackPrefetch: true */ "./scripts/modules/mediaCarouselRow.js")
        .then((m) => {
            if (m?.initMediaCarouselRow) {
                m.initMediaCarouselRow();
            }
        })
        .catch((e) => console.error("[mediaCarouselRow] dynamic import failed", e));
}